import { Scenes } from "../types";
import { GLOBAL_FOCUS_IDS } from "./constants";

export const FOCUSABLES = {
	SPLASH_SCREEN: {
		ENTER_CABIN: "cabin-hub",
	} as const,
	CABIN_HUB: {
		NAV_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		NAV_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		RADIO: "radio",
		GAME_TABLE: "game-table",
		CAT: "cat",
		TV: "tv",
		FIREPLACE: "fireplace",
		LIBRARY: "library",
		WINDOW: "window",
		COUCH: "couch",
		DESK: "desk",
		OWL: "owl",
	} as const,
	CABIN_CAT: {
		PET: "meow",
		NAV_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		NAV_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
	},
	CABIN_COUCH: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		FIREPLACE: "fireplace",
		RADIO: "radio",
		OWL: "owl",
		TV: "tv",
		BOOKSHELF: "bookshelf",
		TABLE: "game-table",
	} as const,
	CABIN_GAME_TABLE: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		CHESS: "chess",
	} as const,
	CABIN_FIREPLACE: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
	} as const,
	CABIN_WINDOW: {
		ARROW_CENTER: GLOBAL_FOCUS_IDS.CENTER_ARROW,
	} as const,
	CABIN_KITCHEN: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
	} as const,
	CABIN_LIBRARY: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		FIREPLACE: "fireplace",
		RADIO: "radio",
		BOOKSHELF: "bookshelf",
	} as const,
	CABIN_DESK: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		CARD_CRAFT: "card-craft",
		DRAWER: "desk-drawer",
	} as const,
	CABIN_DESK_DRAWER: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		TICKETS: "tickets",
	} as const,
	CABIN_EXIT: {
		ARROW_LEFT: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		ARROW_RIGHT: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		LAMP: "lamp",
		EXIT: "cabin-exit",
	} as const,
	CABIN_RADIO: {
		LEFT_ARROW: GLOBAL_FOCUS_IDS.LEFT_ARROW,
		RIGHT_ARROW: GLOBAL_FOCUS_IDS.RIGHT_ARROW,
		TOGGLE: "toggle",
		STATION_CHANGE: "station-change",
		VOLUME_UP: "volume-up",
		VOLUME_DOWN: "volume-down",
	} as const,
	PLANE: {
		SKIP_TO_CABANA: "skip-to-cabana",
	} as const,
	PLANE_RETURN: {
		SKIP_TO_CABIN: "skip-to-cabin",
	} as const,
	CABANA: {
		ARROW_UP: GLOBAL_FOCUS_IDS.CENTER_ARROW,
		PLANE_RETURN: "plane-return",
	} as const,
	CABANA_BEACH: {
		ARROW_DOWN: GLOBAL_FOCUS_IDS.CENTER_ARROW,
	} as const,
	INTERACTIVE_CAT: {
		SKIP: "skip",
	} as const,
} as const satisfies Record<Scenes, Record<string, string>>;
